import FontWeightBoldStyles from './types';

// Web only has ExpensifyNeue-Regular so to achieve bold we need to add this fontWeight
const bold: FontWeightBoldStyles = '700';

export default bold;
